/**
 * DemoWrapper — Adds top padding when the demo timer bar is visible
 * to prevent content from being hidden behind the fixed bar.
 */
import { useDemo } from "@/contexts/DemoContext";

export default function DemoWrapper({ children }: { children: React.ReactNode }) {
  const { isDemo, expired } = useDemo();
  
  // Only add padding when demo timer bar is visible (not expired)
  const showBar = isDemo && !expired;
  
  return (
    <div style={{ paddingTop: showBar ? "36px" : "0" }}>
      {children}
    </div>
  );
}
